"use strict";

function RouteConfig() {
  const get = function () {
    return {
      "2nform": {
        ":tool/:dataView": GeneralRoutes.toolDataViewRoute,
        ":tool/:dataView/to-do/:toDoSubject/prioritize": GeneralRoutes.toDoPrioritizeRoute,

        ":tool/:dataView/bmpFcs/:id/inspection": BmpFcsRoutes.inspectionRoute,
        ":tool/:dataView/bmpFcs/:id/inspection/:inspectionId": BmpFcsRoutes.inspectionRoute,
        ":tool/:dataView/catchBasin/:id/inspection": CatchBasinRoutes.inspectionRoute,
        ":tool/:dataView/catchBasin/:id/inspection/:inspectionId": CatchBasinRoutes.inspectionRoute,
        ":tool/:dataView/outfall/:id/inspection": OutfallRoutes.inspectionRoute,
        ":tool/:dataView/outfall/:id/inspection/:inspectionId": OutfallRoutes.inspectionRoute,
        ":tool/:dataView/manhole/:id/inspection": ManholeRoutes.inspectionRoute,
        ":tool/:dataView/manhole/:id/inspection/:inspectionId": ManholeRoutes.inspectionRoute,
        ":tool/:dataView/pipe/:id/inspection": PipeRoutes.inspectionRoute,
        ":tool/:dataView/pipe/:id/inspection/:inspectionId": PipeRoutes.inspectionRoute,
        ":tool/:dataView/culvert/:id/inspection": CulvertRoutes.inspectionRoute,
        ":tool/:dataView/culvert/:id/inspection/:inspectionId": CulvertRoutes.inspectionRoute,
        ":tool/:dataView/openChannel/:id/inspection": OpenChannelRoutes.inspectionRoute,
        ":tool/:dataView/openChannel/:id/inspection/:inspectionId":
          OpenChannelRoutes.inspectionRoute,
        ":tool/:dataView/liftStation/:id/inspection": LiftStationRoutes.inspectionRoute,
        ":tool/:dataView/liftStation/:id/inspection/:inspectionId":
          LiftStationRoutes.inspectionRoute,
        ":tool/:dataView/cleanout/:id/inspection": CleanoutRoutes.inspectionRoute,
        ":tool/:dataView/cleanout/:id/inspection/:inspectionId": CleanoutRoutes.inspectionRoute,
        ":tool/:dataView/samplingSite/:id/inspection": SamplingSiteRoutes.inspectionRoute,
        ":tool/:dataView/samplingSite/:id/inspection/:inspectionId":
          SamplingSiteRoutes.inspectionRoute,

        // Permanent redirects from the old asset-first inspection URLs, kept so bookmarks and shared
        // links still open. routineRepair is from historical Esri inspections.
        "asset/bmpFcs/:id/routineInspection": BmpFcsRoutes.legacyRedirectRoute,
        "asset/bmpFcs/:id/routineInspection/:inspectionId": BmpFcsRoutes.legacyRedirectRoute,
        "asset/bmpFcs/:id/routineRepair": BmpFcsRoutes.legacyRedirectRoute,
        "asset/bmpFcs/:id/routineRepair/:inspectionId": BmpFcsRoutes.legacyRedirectRoute,
        "asset/catchBasin/:id/routineInspection": CatchBasinRoutes.legacyRedirectRoute,
        "asset/catchBasin/:id/routineInspection/:inspectionId":
          CatchBasinRoutes.legacyRedirectRoute,
        "asset/catchBasin/:id/routineRepair": CatchBasinRoutes.legacyRedirectRoute,
        "asset/catchBasin/:id/routineRepair/:inspectionId": CatchBasinRoutes.legacyRedirectRoute,
        "asset/outfall/:id/routineInspection": OutfallRoutes.legacyRedirectRoute,
        "asset/outfall/:id/routineInspection/:inspectionId": OutfallRoutes.legacyRedirectRoute,
        "asset/outfall/:id/routineRepair": OutfallRoutes.legacyRedirectRoute,
        "asset/outfall/:id/routineRepair/:inspectionId": OutfallRoutes.legacyRedirectRoute,
        "asset/outfall/:id/dryWeatherScreening": OutfallRoutes.legacyDryWeatherRedirectRoute,
        "asset/outfall/:id/dryWeatherScreening/:inspectionId":
          OutfallRoutes.legacyDryWeatherRedirectRoute,
        "asset/manhole/:id/routineInspection": ManholeRoutes.legacyRedirectRoute,
        "asset/manhole/:id/routineInspection/:inspectionId": ManholeRoutes.legacyRedirectRoute,
        "asset/samplingSite/:id/inspection": SamplingSiteRoutes.legacyRedirectRoute,
        "asset/samplingSite/:id/inspection/:inspectionId": SamplingSiteRoutes.legacyRedirectRoute,

        "muni/muni-catch-basin/data/fact-sheet/:id":
          MuniCatchBasinFactSheetController.catchBasinFactSheetRoute,
        "muni/muni-catch-basin/data/fact-sheet/:id#:highlightId":
          MuniCatchBasinFactSheetController.catchBasinFactSheetHighlightRoute,

        "idde/dry-weather/data/fact-sheet/:id": IddeRoutes.factSheetRoute,
        "idde/incidents/data/fact-sheet/:id": IddeRoutes.incidentFactSheetRoute,
        "idde/incidents/data/fact-sheet/:id#:highlightId":
          IddeRoutes.incidentFactSheetHighlightRoute,

        "outmon/outfalls/data/fact-sheet/:id": WqRoutes.outfallsFactSheetRoute,
        "outmon/wq-monitoring/data/fact-sheet/:id": WqRoutes.wqMonitoringFactSheetRoute,

        "muni/muni-outfalls/data/fact-sheet/:id":
          MuniOutfallFactSheetController.outfallFactSheetRoute,
        "muni/muni-outfalls/data/fact-sheet/:id#:highlightId":
          MuniOutfallFactSheetController.outfallFactSheetHighlightRoute,

        "lid/lid-project/data/fact-sheet/:id": ConstructionRoutes.lidProjectFactSheetRoute,
        "lid/lid-project/data/fact-sheet/:id#:highlightId":
          ConstructionRoutes.lidProjectFactSheetHighlightRoute,

        "construction/construction-project/data/fact-sheet/:id":
          ConstructionRoutes.projectFactSheetRoute,
        "construction/construction-project/data/fact-sheet/:id#:highlightId":
          ConstructionRoutes.projectFactSheetHighlightRoute,

        "projdelivery/construction-project-delivery/data/fact-sheet/:id":
          ConstructionRoutes.projectDeliveryFactSheetRoute,

        "indcom/indcom-facilities/data/fact-sheet/:id":
          FacilityFactSheetNewController.facilityFactSheetRoute,
        "indcom/indcom-facilities/data/fact-sheet/:id#:highlightId":
          FacilityFactSheetNewController.facilityFactSheetHighlightRoute,

        "bmpram/bmp/data/fact-sheet/:id": StructuralBmpFactSheetController.sbmpFactSheetRoute,
        "bmpram/bmp/data/fact-sheet/:id#:highlightId":
          StructuralBmpFactSheetController.sbmpFactSheetHighlightRoute,

        "muni/muni-bmp/data/fact-sheet/:id": MuniBmpFactSheetController.muniBmpFactSheetRoute,
        "muni/muni-bmp/data/fact-sheet/:id#:highlightId":
          MuniBmpFactSheetController.muniBmpFactSheetHighlightRoute,

        "muni/muni-pipes/data/fact-sheet/:id": MuniHardAssetFactSheetController.pipeFactSheetRoute,
        "muni/muni-pipes/data/fact-sheet/:id#:highlightId":
          MuniHardAssetFactSheetController.pipeFactSheetHighlightRoute,

        "muni/muni-manhole/data/fact-sheet/:id":
          MuniHardAssetFactSheetController.manholeFactSheetRoute,
        "muni/muni-manhole/data/fact-sheet/:id#:highlightId":
          MuniHardAssetFactSheetController.manholeFactSheetHighlightRoute,

        "muni/muni-culvert/data/fact-sheet/:id":
          MuniHardAssetFactSheetController.culvertFactSheetRoute,
        "muni/muni-culvert/data/fact-sheet/:id#:highlightId":
          MuniHardAssetFactSheetController.culvertFactSheetHighlightRoute,

        "muni/muni-open-channel/data/fact-sheet/:id":
          MuniHardAssetFactSheetController.openChannelFactSheetRoute,
        "muni/muni-open-channel/data/fact-sheet/:id#:highlightId":
          MuniHardAssetFactSheetController.openChannelFactSheetHighlightRoute,

        "muni/muni-lift-stations/data/fact-sheet/:id":
          MuniHardAssetFactSheetController.liftStationFactSheetRoute,
        "muni/muni-lift-stations/data/fact-sheet/:id#:highlightId":
          MuniHardAssetFactSheetController.liftStationFactSheetHighlightRoute,

        "muni/muni-cleanout/data/fact-sheet/:id":
          MuniHardAssetFactSheetController.cleanoutFactSheetRoute,
        "muni/muni-cleanout/data/fact-sheet/:id#:highlightId":
          MuniHardAssetFactSheetController.cleanoutFactSheetHighlightRoute,

        "lid/lid-bmp/data/fact-sheet/:id": LidBmpFactSheetController.lidBmpFactSheetRoute,
        "lid/lid-bmp/data/fact-sheet/:id#:highlightId":
          LidBmpFactSheetController.lidBmpFactSheetHighlightRoute,
      },
      esg: {
        "": EsgRoutes.homeRoute,
        "impact-accounting": EsgRoutes.stormwaterImpactAccountingRoute,
        "impact-accounting/stormwater-plans": EsgRoutes.plansRoute,
        "impact-accounting/stormwater-plans/:planSlug": EsgRoutes.planRoute,
        "impact-accounting/stormwater-plans/edit-info/:planSlug": EsgRoutes.planInfoRoute,
        "impact-accounting/stormwater-plans/:planSlug/impact": EsgRoutes.impactRoute,
        "impact-accounting/stormwater-plans/:planSlug/selected": EsgRoutes.selectedPropertiesRoute,
        "impact-accounting/stormwater-plans/:planSlug/selected/:propertySlug":
          EsgRoutes.propertyFactSheetRouteForPlanSelected,
        "impact-accounting/stormwater-plans/:planSlug/suitable": EsgRoutes.suitablePropertiesRoute,
        "impact-accounting/stormwater-plans/:planSlug/suitable/:propertySlug":
          EsgRoutes.propertyFactSheetRouteForPlanSuitable,
        portfolio: EsgRoutes.stormwaterOpportunityRoute,
        "portfolio/stormwater-plans/:planSlug": EsgRoutes.planRoute,
        "portfolio/properties": EsgRoutes.propertiesRoute,
        "portfolio/properties/:propertySlug": EsgRoutes.propertyFactSheetRoute,
        "portfolio/incentive-programs": EsgRoutes.incentiveProgramsRoute,
      },
      portal: {
        ":secret": PortalRoutes.goToFormRoute,
        ":secret/post-construction-response": PortalRoutes.lidSelfInspectionResponseRoute,
        ":secret/post-construction-response/confirm":
          PortalRoutes.lidSelfInspectionConfirmationRoute,
        ":secret/industrial-commercial-response":
          PortalRoutes.indcomFacilitySelfInspectionResponseRoute,
        ":secret/industrial-commercial-response/confirm":
          PortalRoutes.indcomFacilitySelfInspectionConfirmationRoute,
      },
    };
  };

  return { get };
}

module.exports = RouteConfig();

const BmpFcsRoutes = require("../routes/2nform/bmpFcsRoutes");
const CatchBasinRoutes = require("../routes/2nform/catchBasinRoutes");
const CleanoutRoutes = require("../routes/2nform/cleanoutRoutes");
const CulvertRoutes = require("../routes/2nform/culvertRoutes");
const LiftStationRoutes = require("../routes/2nform/liftStationRoutes");
const ManholeRoutes = require("../routes/2nform/manholeRoutes");
const OpenChannelRoutes = require("../routes/2nform/openChannelRoutes");
const OutfallRoutes = require("../routes/2nform/outfallRoutes");
const PipeRoutes = require("../routes/2nform/pipeRoutes");
const IddeRoutes = require("../routes/2nform/iddeRoutes");
const GeneralRoutes = require("../routes/2nform/generalRoutes");
const EsgRoutes = require("../routes/esg/esgRoutes");
const PortalRoutes = require("../routes/portal/portalRoutes");
const SamplingSiteRoutes = require("../routes/2nform/samplingSiteRoutes");
const ConstructionRoutes = require("../routes/2nform/constructionRoutes");
const FacilityFactSheetNewController = require("../indcom/facilityFactSheetNewController");
const StructuralBmpFactSheetController = require("../bmpfcs/structuralBmpFactSheetController");
const MuniBmpFactSheetController = require("../muni/muniBmpFactSheetController");
const MuniOutfallFactSheetController = require("../muni/muniOutfallFactSheetController");
const MuniCatchBasinFactSheetController = require("../muni/muniCatchBasinFactSheetController");
const MuniHardAssetFactSheetController = require("../muni/muniHardAssetFactSheetController");
const LidBmpFactSheetController = require("../lid/lidBmpFactSheetController");
const WqRoutes = require("../routes/2nform/wqRoutes");
